import createReducer from 'arts/config/create_reducer';
import Constants from 'arts/config/constants';
import { toCamelCase } from '../../wall_builder/config/utils';

const getDefaultState = () => ({
  loading: false,
  items: toCamelCase(window.collections || [])
});

export default createReducer(getDefaultState(), {
  [Constants.Collections.LOAD]: () => ({
    ...getDefaultState(),
    loading: true
  }),
  [Constants.Collections.LOADED]: (_, { items }) => ({
    loading: false,
    items
  })
});
